export interface UserListResponse {
  users: UserResponse[];
}
export interface UserResponse {
  firstName: string;
  lastName: string;
  emailAddress: string | null;
  userId: string;
  manualBlockDate: string | null;
  accountLevel: AccountLevel | null;
}
export const AccountLevels = ['Free', 'Basic', 'Premium'] as const;
export type AccountLevel = (typeof AccountLevels)[number];
